/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum QueueItemStatus {
    NEW = 'New',
    PENDING = 'Pending',
    COMPLETED = 'Completed',
    FAILED = 'Failed',
    RETRY = 'Retry',
    CANCELLED = 'Cancelled',
}
